import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/rolls/strawberry rolls.png";
import BiscuitImg from "../../../assets/products/rolls/Straberry-Roll.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 4,
  },
  {
    grams: 15,
  },
  {
    grams: 18,
  },
];

export default function StrawberryRollProduct() {
  return (
    <>
      <Helmet>
        <title>Strawberry Roll – BearBitz | Premium Biscuits & Rolls</title>
        <meta
          name="description"
          content="Explore BearBitz Strawberry Rolls — crispy rolled wafers filled with creamy strawberry flavor. View pack sizes and specs."
        />
        <meta
          name="keywords"
          content="Strawberry Roll, BearBitz Strawberry Roll"
        />
        <link rel="canonical" href="https://www.bearbitz.in/rolls/strawberryroll" />
        <meta property="og:title" content="Strawberry Roll – BearBitz" />
        <meta
          property="og:description"
          content="Crispy rolled wafer dessert filled with strawberry cream by BearBitz, export-quality."
        />
      </Helmet>

      <ProductTemplate
        productTitle="STRAWBERRY"
        productImage={BisImg}
        description="Rolled for Flavor, Baked for Crunch Delicious cylindrical wafer rolls packed with rich cream fillings, offering a delightful crunch with every bite. Available in various tempting flavors, they make for a premium snacking experience and a perfect pairing with beverages. Popular in gift packs and premium retail shelves across global markets."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#FF009F"
        sectionBgColor="#FFDBF4"
        productBgcolor="#FFADE6"
        tableheadBgcolor="#FF009F"
        tableBgcolor="#FFF1FB"
        footerBgcolor="#FF009F"
      />
    </>
  );
}
